import { render, staticRenderFns } from "./QuestionnaireAnswer.vue?vue&type=template&id=ceec62b8&"
import script from "./QuestionnaireAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
